import { MessageSquare } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface ExplainButtonProps {
  onClick: () => void;
  ariaLabel: string;
  testId: string;
}

/** The app's Explain button, as used across the record components. */
export default function ExplainButton({ onClick, ariaLabel, testId }: ExplainButtonProps) {
  const { t } = useTranslation();
  return (
    <button
      onClick={onClick}
      className="bg-white border border-gray-300 hover:border-primary text-primary hover:bg-primary hover:text-white px-2.5 py-1.5 rounded-md text-xs font-medium flex items-center gap-1.5 transition-all shadow-sm whitespace-nowrap flex-shrink-0"
      data-testid={testId}
      aria-label={ariaLabel}
    >
      <MessageSquare className="h-3 w-3" />
      {t('explain.buttonLabel')}
    </button>
  );
}
